export default "/images/332587e8ad642d1e334a9a50fef3612e.avif";